import type { MarkdownOverrides } from "@expert/solve-tools";
import type { TextProps } from "@mantine/core";

import { List, Text } from "@mantine/core";

function ParagraphOverride(props: TextProps) {
    return <Text size="xs" p="0" {...props} />;
}

const listOverride: MarkdownOverrides = {
    ol: {
        component: List,
        props: {
            type: "ordered",
            size: "xs",
            spacing: "3xs",
            withPadding: true,
            style: {
                listStylePosition: "outside",
                marginLeft: "sm",
                marginBottom: "3xs",
            },
        },
    },
    ul: {
        component: List,
        props: {
            type: "unordered",
            listStyleType: "disc",
            size: "xs",
            spacing: "3xs",
            withPadding: true,
            style: {
                listStylePosition: "outside",
                marginLeft: "sm",
                marginBottom: "3xs",
            },
        },
    },
    li: {
        component: List.Item,
    },
};

export const markdownOverrides = {
    ...listOverride,
    p: { component: ParagraphOverride },
};
